import Vue from 'vue';
import store from '../store';
import snackbar from './snackbar';
import filter from './filter';
import VueScrollbar from 'vue-scrollbar-simple';
import Pagination from '../components/Pagination.vue';
import DateRangePicker from '../components/DateRangePicker.vue';
import DateTimeRangePicker from '../components/DateTimeRangePicker.vue';
// Added.by.KWShin.2024.09.04.
import DateTimeRangePickerNeo from '../components/DateTimeRangePickerNeo.vue';
import DateTimeRangeNavigator from '../components/DateTimeRangeNavigator.vue';
import TimeNavigator from '../components/TimeNavigator.vue';
// Added.by.KWShin.2024.02.28.
import TimeNavigatorNeo from '../components/TimeNavigatorNeo.vue';
import ProgressLinear from '../components/ProgressLinear.vue';
import SystemLinkedCombo from '../components/SystemLinkedCombo.vue';
import SectionTimeBar from '../components/SectionTimeBar.vue';
import TreeDataTable from '../components/ntree/TreeDataTable.vue';
import Chart from '../components/chart';
// Added.by.KWShin.2025.09.19.
import DownloadButton from '../components/DownloadButton.vue';
// BEGIN::Modified.by.KWShin.2024.01.12.
// import otlet from '../components/motlet';
import { Motlet, MotletNeo } from '../components/motlet';
// FINISH::Modified.by.KWShin.2024.01.12.
import PageTitle from '../views/common/PageTitle';
import websocket from './websocket';
// Added.by.KWShin.2026.09.09. 목록 셀 설명 풍선글(이벤트 위임 방식)
import descTooltip from './descTooltip';

Vue.use(websocket, { store });
Vue.use(snackbar, { store });
Vue.use(filter);
Vue.use(descTooltip);
Vue.use(VueScrollbar);
Vue.component('pagination', Pagination);
Vue.component('date-range-picker', DateRangePicker);
Vue.component('date-time-range-picker', DateTimeRangePicker);
// Added.by.KWShin.2024.09.04.
Vue.component('date-time-range-picker-neo', DateTimeRangePickerNeo);
Vue.component('date-time-range-navigator', DateTimeRangeNavigator);
Vue.component('time-navigator', TimeNavigator);
// Added.by.KWShin.2024.02.28.
Vue.component('time-navigator-neo', TimeNavigatorNeo);
Vue.component('progress-linear', ProgressLinear);
Vue.component('system-linked-combo', SystemLinkedCombo);
Vue.component('section-time-bar', SectionTimeBar);
Vue.component('tree-data-table', TreeDataTable);
Vue.component('v-chart', Chart);
Vue.component('download-button', DownloadButton);
Vue.component('motlet', Motlet);
// Added.by.KWShin.2024.01.12.
Vue.component('motlet-neo', MotletNeo);
Vue.component('page-title', PageTitle);
